import { Apollo } from "apollo-angular";
import {
  Component,
  OnInit,
  OnDestroy,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatDialogRef } from "@angular/material/dialog";
import { FormGroup, FormBuilder } from "@angular/forms";
import { updateOT } from "./../../../../models/graphQL/mutations/updateOT.mutation";
import { mongoMaestrosRequest } from "./../../../../models/graphQL/mongoMaestros.request";
import { findDispositivos } from "./../../../../models/graphQL/findDispositivos.request";
import { OrdenesServiceService } from "src/app/services/ordenes/ordenes-service.service";
import { LoginService } from "src/app/services/login/login.service";
import * as _ from "lodash";

@Component({
  selector: "app-edit-ot-modal",
  templateUrl: "./editOTmodal.component.html",
})
export class EditOTModalComponent implements OnInit, OnDestroy {
  addNewOrderForm: FormGroup;
  status_options: string[];
  maestrosModels: any[];
  dispositivosOptions: any[];
  piezasColumn: string;
  duracion: any;
  bandejasSalida: any;
  userRole: any;
  @Output() toastRequest = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<EditOTModalComponent>,
    private formBuilder: FormBuilder,
    public apollo: Apollo,
    private ordersService: OrdenesServiceService,
    private loginService: LoginService
  ) {
    this.addNewOrderForm = this.formBuilder.group({
      orden: this.data.row.orden,
      colada: this.data.row.colada,
      clave: this.data.row.clave,
      modelo: this.data.row.modelo.modelo,
      disp: this.data.row.disp,
      dispUUID: this.data.row.dispUUID,
      inicio: this.data.row.inicio,
      fin: this.data.row.fin,
      estado: this.data.row.estado,
      bono: this.data.row.bono,
    });
    this.status_options = [
      "ot_not_started",
      "ot_started",
      "ot_finished",
      "ot_validated",
    ];
  }

  ngOnInit() {
    this.findDataMaestros();
    this.findDispositivos();
    this.userRole = this.loginService.currentUserValue.rol;
  }

  findDataMaestros() {
    this.maestrosModels = [];
    this.apollo
      .query<any>({
        query: mongoMaestrosRequest,
        variables: {
          _id: "maestros",
        },
      })
      .subscribe(({ data, errors }) => {
        this.maestrosModels = data.findMaestros;
      });
  }

  editOT() {
    this.editOTMutation();
  }

  findDispositivos() {
    this.apollo
      .query<any>({
        query: findDispositivos,
      })
      .subscribe(({ data, errors }) => {
        this.dispositivosOptions = data.findDispositivos;
      });
  }

  editOTMutation() {
    this.checkStateForDuration(this.addNewOrderForm.value.estado);
    this.apollo
      .mutate<any>({
        mutation: updateOT,
        variables: {
          _id: this.data.row._id,
          input: {
            orden: this.addNewOrderForm.value.orden,
            colada: this.addNewOrderForm.value.colada,
            clave: this.addNewOrderForm.value.clave,
            modelo: _.omit(
              this.maestrosModels.filter(
                (r) => r.modelo == this.addNewOrderForm.value.modelo
              )[0],
              ["__typename", "_id"]
            ),
            dispUUID: this.addNewOrderForm.value.dispUUID,
            disp: this.dispositivosOptions.filter(
              (r) => r.uuid == this.addNewOrderForm.value.dispUUID
            )[0].nombre,
            inicio: this.convertDateForm(this.addNewOrderForm.value.inicio),
            fin: this.convertDateForm(this.addNewOrderForm.value.fin),
            estado: this.addNewOrderForm.value.estado,
            duracion: this.duracion,
            bono: this.addNewOrderForm.value.bono,
          },
        },
      })
      .subscribe(({ data }) => {
        this.toastRequest.next(data);
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  convertDateForm(date: any) {
    switch (typeof date) {
      case "object":
        if (date != null) {
          return date.getTime();
        } else {
          return null;
        }
      case "number":
        return date;
    }
  }

  checkStateForDuration(status: string) {
    switch (status) {
      case "ot_not_started":
        this.addNewOrderForm.value.inicio = null;
        this.addNewOrderForm.value.fin = null;
        return (this.duracion = null);
      case "ot_started":
        this.addNewOrderForm.value.fin = null;
        return (this.duracion = null);
      case "ot_finished":
      case "ot_validated":
        return (this.duracion =
          (this.addNewOrderForm.value.fin - this.addNewOrderForm.value.inicio) /
          60000);
    }
  }

  ngOnDestroy() {}
}
